export default __webpack_public_path__ + "static/media/car-gear.2e9e2252.svg";